<template>
  <div class="form-layout">
    <div v-if="!isOutsideChain">
      <label class="component-title">{{component.name}}</label>
    </div>
    <!--外链头部内容-->
    <div class="outside-chain-top" v-else>
      <div v-show="!outsideChainData.isEditName" @click.stop="editOutSideChainName" class="showName">
        {{outsideChainData.pageName}}
        <i class="el-icon-edit-outline"></i>
      </div>
      <el-input class="edit" v-show="outsideChainData.isEditName" ref="inputName" @keyup.enter.native="inputBlur"
                @blur="inputBlur" v-model='outsideChainData.pageName'></el-input>
      <div>
        <el-upload
          class="avatar-uploader"
          action="/shared-api/files/uploadFiles"
          :show-file-list="false"
          :headers="outsideChainData.headers"
          :before-upload="beforeAvatarUpload"
          :on-success="handleAvatarSuccess">
          <img v-if="outsideChainData.imageUrl" :src="loadImg(outsideChainData.imageUrl)" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <div class="logo">LOGO</div>
      </div>
    </div>
    <!--rc-form主体内容-->
    <draggable class="layout-form" ref="draggable" v-model="component.children">
      <transition-group name="list-component">
        <div
          class="list-component-item"
          v-for="item in component.children"
          :key="item.id"
          :class="[{'list-component-item-select': selectId===item.id}, item.componentType]"
          @click.stop="openAttrForChildren(item)">
          <i class="delete-component"  @click.stop="removeComponent(item)"></i>
          <component
            ref="childrenComponent"
            :is="item.componentType"
            :initComponent="item"
            :selectId="selectId"
            :highlightId="highlightId"
            :nodeIsCountersign="nodeIsCountersign"
            :parentComponent="component">
          </component>
        </div>
      </transition-group>
    </draggable>
    <!--外链底部按钮编辑-->
    <div v-if="isOutsideChain" class="outside-chain-bottom">
      <div  v-show="!outsideChainData.isEditButtonName" class="showButtonName" @click.stop="editOutSideChainButtonName">
        {{outsideChainData.buttonName}}&nbsp;<i class="el-icon-edit-outline"></i>
      </div>
      <el-input v-show="outsideChainData.isEditButtonName" ref="inputButtonName" @blur="buttonInputBlur"  @keyup.enter.native="buttonInputBlur"
                v-model='outsideChainData.buttonName'></el-input>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import Draggable from 'vuedraggable'
import interact from 'interactjs'
import { offsetXYFromParentOf } from '../../dragUtil'
import { getProperties } from '@/store/form/componentDefaults.js'
import { childrenSortMixin } from '@/components/shared/designAndRuntimeMixins/mixins.js'
import RcGroup from '../group/rc-group.vue'
import RcLayout from '../layout/rc-layout.vue'
import { findVueMixin } from '@/components/form/runtime/components/findVue.js'
import tokenStorage from '@/plugins/tokenStorage'
import { ColumnComponent, TableComponent } from '@/store/form/component.js'

const acceptComponent = ['rc-group', 'rc-layout']

export default {
  name: 'rc-form',
  inject: ['formService', 'componentEventBus', 'componentCount', 'sortComponent'],
  props: ['component', 'selectId', 'nodeIsCountersign', 'isOutsideChain', 'outSideChainName', 'outSideChainButtonName', 'outSideChainImageUrl', 'processSaveState', 'highlightId'],
  mixins: [childrenSortMixin, findVueMixin],
  data () {
    return {
      preventDragOpen: {openAttr: true, x: '', y: ''},
      page: {
        dragger: {
          dragging: false,
          mouseOffset: {}
        }
      },
      //  外链所需属性
      outsideChainData: {
        isEditName: false,
        //  外链名称
        pageName: this.outSideChainName,
        //  外链logo
        imageUrl: this.outSideChainImageUrl,
        //  按钮名称
        buttonName: this.outSideChainButtonName,
        isEditButtonName: false,
        headers: {'Authorization': tokenStorage.getToken()}
      }
    }
  },
  components: {
    Draggable,
    RcGroup,
    RcLayout
  },
  created () {
    this.childrenSort(this.component)
    // 编辑进来全部的控件遍历取个数
    this.component.allChildren.forEach(m => {
      this.componentCount[m.componentType] = !this.componentCount[m.componentType] ? m.properties.count : this.componentCount[m.componentType] < m.properties.count ? m.properties.count : this.componentCount[m.componentType]
    })
  },
  mounted () {
    let _this = this
    interact('.layout-form').dropzone({
      // only accept elements matching this CSS selector
      accept: '.component-template',
      ondragenter: function (event) {
        // 进入当前容器区域时
      },
      ondragleave: function (event) {
        // 离开当前容器区域
      },

      ondrop: _.debounce((event) => {
        let componentType = event.dragEvent.currentTarget.getAttribute('component-type')
        let componentName = event.dragEvent.currentTarget.getAttribute('component-name')
        if (acceptComponent.includes(componentType)) {
          let position = offsetXYFromParentOf(event)
          let componentHeights = []
          let components = _this.$refs.draggable.$el.children[0].children

          for (let i = 0, length = components.length; i < length; i++) {
            componentHeights.push(components[i].offsetHeight + 10)
          }

          let index = componentHeights.length ? componentHeights.length + 1 : 0
          for (let j = 0, length = componentHeights.length; j < length; j++) {
            let top = componentHeights.slice(0, j).reduce((x, y) => x + y, 0)
            let bottom = top + componentHeights[j]
            if (top < position.y && position.y < bottom) {
              if ((position.y - top) > (componentHeights[j] / 2)) {
                // 放下面
                index = j + 1
              } else {
                // 放上面
                index = j
              }
              break
            }
          }
          _this.addComponent({componentType, componentName, index})
        }
      })

    })
    this.$nextTick(() => { this.sortComponent.state = true })
  },
  methods: {
    async addComponent (params) {
      let componentType = params.componentType
      let component = getProperties(componentType)

      if (componentType === 'rc-layout') {
        component.defaults.name = params.componentName
      }
      let pinyin = await this.formService.getPinyinByHanzi(component.defaults.name)
      component.defaults.pinyinName = pinyin.pinyinName
      component.defaults.pinyinFirstChar = pinyin.pinyinFirstChar
      let cm = this.formService.createComponent(component, this.component, params.index)
      this.$nextTick(() => {
        let table = this.formService.schema.getTable(cm.archive.tableId)
        // 表格不需要改列的值
        if (cm.componentType === 'rc-table') {
          table.pinyinName = pinyin.pinyinName
          table.pinyinFirstChar = pinyin.pinyinFirstChar
        } else {
          if (table && table.columns) {
            let c = table.columns.find(c => c.id === cm.archive.columnId)
            c.pinyinName = pinyin.pinyinName
            c.pinyinFirstChar = pinyin.pinyinFirstChar
          }
        }
      })
    },
    openAttrForChildren (component) {
      if (this.preventDragOpen.openAttr && !['rc-draggable', 'rc-layout'].some(n => n === component.componentType)) {
        this.componentEventBus.$emit('changeLeftPanel', {state: 'ComponentAttr', id: component.id})
      }
    },
    removeComponent (component) {
      this.$confirm('', '你确定要删除吗,全部的子控件也会删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'publishMessageBox',
        center: true
      }).then(res => {
        this.componentEventBus.$emit('changeLeftPanel', {state: 'ComponentList', id: component.id})
        // 首先检查要删除的控件是不是有自定义的删除前置事件, 如果有的话, 优先执行前置事件
        let currenComponent = this.$refs.childrenComponent.find(m => m.component === component)
        if (currenComponent && currenComponent.remove) {
          currenComponent.remove()
        }
        this.formService.removeComponent(component)
      })
    },
    collectComponent (component) {
      component.collected = !component.collected
    },
    //  获取所有的元素外链用
    getAllVue (type) {
      if (type === 1) {
        return this.findAllVue2(this)
      } else if (type === 2) {
        return this.findAllVue2(this).filter(el => {
          if ((el.component && (el.component instanceof ColumnComponent || el.component instanceof TableComponent)) ||
            (el.initComponent && ['rc-textarea', 'rc-radio', 'rc-checkbox'].includes(el.initComponent.componentType))
          ) {
            return el
          }
        })
      }
    },
    //  编辑外链title
    editOutSideChainName () {
      this.outsideChainData.isEditName = true
      this.$nextTick(() => {
        this.$refs.inputName.focus()
      })
    },
    //  编辑外链底部按钮
    editOutSideChainButtonName () {
      this.outsideChainData.isEditButtonName = true
      this.$nextTick(() => {
        this.$refs.inputButtonName.focus()
      })
    },
    //  外链title失焦
    inputBlur () {
      this.$emit('editOutSideChainName', this.outsideChainData.pageName)
      this.outsideChainData.isEditName = false
    },
    //  外链底部按钮失焦
    buttonInputBlur () {
      this.$emit('editOutSideChainButtonName', this.outsideChainData.buttonName)
      this.outsideChainData.isEditButtonName = false
    },
    //  上传logo
    handleAvatarSuccess (res, file) {
      this.outsideChainData.imageUrl = res[0].result.dir
      this.$emit('editOutSideChainlogo', res[0].result.dir)
    },
    //  上传logo校验
    beforeAvatarUpload (file) {
      const isImg = file.type.indexOf('image') !== -1
      if (!isImg) {
        this.$message.error('只能上传图片!')
      }
      return isImg
    },
    //  加载logo的url
    loadImg (url) {
      let src = ''
      if (url) {
        src = url.indexOf('USER') !== -1 ? sessionStorage.getItem('ossDownloadUrl') + url : sessionStorage.getItem('ossDownloadUrl') + url
      }
      return src
    }
  },
  watch: {
    'component.children' (val) {
      this.component.properties.childrenSort = val.map(n => n.id)
    },
    processSaveState (val) {
      if (val) {
        this.childrenSort(this.component)
      }
    }
  }
}
</script>

<style lang="scss">
  .form-layout {
    position: relative;
    height: calc(100% - 116px);
    margin-top: 10px;
    border-bottom: 1px solid #ebebeb;
    overflow: auto;
    .vue-grid-item.vue-grid-placeholder {
      background-color: #ccc;
    }

    .layout-form {
      margin: 0 10px;
      min-height: 600px;
      border-bottom: 1px solid #ccc;
      padding-bottom: 20px;
      background: #fff;

      .list-component-enter, .list-component-leave-active {
        opacity: 0;
      }

      fieldset {
        width: 100%;
        height: 100%;
        padding-left: 10px;
        padding-right: 10px;
        border: 1px solid #EBEBEB;
        border-left: none;
        border-right: none;

        legend {
          margin-left: 20px;
          padding: 0 10px;
        }
      }

      .list-component-item.rc-layout,.list-component-item.rc-group, .list-component-item.rc-draggable {
        background: #fff;
        padding: 0;
       &.list-component-item-select {
          fieldset {
            border: 1px solid #54ABF1;
          }
        }
      }
      .list-component-item.rc-group, .list-component-item.rc-group.list-component-item-select {
          border: none;
       }
      .list-component-item {
        position: relative;
        background: #fff;
        padding: 12px 2px;
        transition: all 0.3s;
        border: 1px solid transparent;
        &.list-component-item-select {
          border: 1px solid #55ACF1;
         >.delete-component,>.collecte-component {
            display: block;
          }
        }

        .is-disabled .el-input__inner {
          background-color: inherit;
        }

       .is-disabled.onlyread .el-input__inner,.onlyread .is-disabled .el-input__inner {
          background-color: #f5f7fa;
        }
        label.item-name {
          display: block;
          width: 100px;
          padding-right: 12px;
          float: left;
          color: #181818;
          font-size: 14px;
          line-height: 28px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;

          .required {
            color: #f56c6c;
            margin-right: 4px;
          }
        }
        > div > div.component-content {
          height: 100%;
          padding-left: 100px;
          font-size: 12px;
        }

        .delete-component {
          right: 6px;
          position: absolute;
          top: -1px;
          display: none;
          font-size: 12px;
          color: #55ACF1;
          cursor: pointer;
          z-index: 10;
          color: #AFB0B1;
          width: 12px;
          height: 12px;
          background: url('../../design/assets/delect-deafult.png') no-repeat;
          &:hover {
            background: url('../../design/assets/delect-hover.png') no-repeat;
          }
          &:active {
             background: url('../../design/assets/delect-active.png') no-repeat;
          }
        }
        .collecte-component {
          right: 22px;
          width: 12px;
          height: 12px;
          position: absolute;
          top: -1px;
          display: none;
          font-size: 12px;
          color: #55ACF1;
          cursor: pointer;
          z-index: 10;
          background: url('../../design/assets/copy-default.png') no-repeat;
          &:hover {
            background: url('../../design/assets/copy-hover.png') no-repeat;
          }
           &:active {
             background: url('../../design/assets/copy-click.png') no-repeat;
          }
        }
      }

    }
    .list-component-item:hover{
      background-color: #F7FBFF;
    }
    .outside-chain-bottom{
      height: 60px;
      width: 100%;
      text-align: center;
      line-height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      .showButtonName{
        width: 120px;
        height: 30px;
        line-height: 30px;
        box-sizing: border-box;
        font-size: 14px;
        color: #ffffff;
        background: #54ABF1;
        .el-icon-edit-outline{
          font-size: 15px;
        }
      }
      .el-input{
        width: 130px;
      }
    }
    .outside-chain-top{
      height: 120px;
      margin: 0 20px;
      padding-top: 30px;
      border-bottom: 1px solid #ddd;
      font-size: 18px;
      display: flex;
      justify-content: space-between;
      .showName{
        width: 200px;
        height: 28px;
        line-height: 28px;
        box-sizing: border-box;
        padding: 0 16px;
        font-size: 18px;
        .el-icon-edit-outline{
          font-size: 18px;
          color: #54ABF1;
        }
      }
      .edit{
        width: 200px;
      }
      .logo{
        text-align: center;
      }
    }
  }
  .archived-message-box {
    .el-message-box__message {
      >p {
        margin: 0 auto;
        width: 200px;
        .tip{
          margin-top: 20px;
          font-size: 10px;
          color: red;
        }
      }
    }
  }
  .outside-chain-top{
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        text-align: center;
        width: 90px;
        height: 58px;
      }
      .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
      }
      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 90px;
        padding: 15px 0;
        text-align: center;
      }
      .avatar {
        width: 100%;
        height:100%;
        display: block;
      }
  }

</style>



// WEBPACK FOOTER //
// src/components/form/components/form/rc-form.vue